module.exports = __webpack_public_path__ + "static/media/weathered-oak-vintage.bf9c3cdf.jpg";